var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProg12(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 27.7778C5 27.7778 0 32.7778 0 38.8889C0 45 5 50 11.1111 50C17.2222 50 22.2222 45 22.2222 38.8889C22.2222 32.7778 17.2222 27.7778 11.1111 27.7778ZM27.7778 0C21.6667 0 16.6667 5 16.6667 11.1111C16.6667 17.2222 21.6667 22.2222 27.7778 22.2222C33.8889 22.2222 38.8889 17.2222 38.8889 11.1111C38.8889 5 33.8889 0 27.7778 0ZM44.4444 27.7778C38.3333 27.7778 33.3333 32.7778 33.3333 38.8889C33.3333 45 38.3333 50 44.4444 50C50.5556 50 55.5556 45 55.5556 38.8889C55.5556 32.7778 50.5556 27.7778 44.4444 27.7778Z",
    fill: "#972682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProg12);
export default __webpack_public_path__ + "static/media/prog12.94f49920cba2eb9985b1f99b2b884fb9.svg";
export { ForwardRef as ReactComponent };